export const UPLOAD_SINGLE_FILE = 1;
